const _ = require('underscore');
const productService = require('services/productService');

const createWorkspaceFromAssignment = assignment => {
	return productService.get(assignment.p).then(product => {
		let articles = product.articles;
		let articleMap = undefined;

		if (product.productType === 'AAD') {
			articleMap = Object.keys(articles).reduce((acc, pid) => {
				acc[pid] = {};
				return acc;
			}, {});

			if (assignment.opts.challenge) {
				Object.keys(product.supplemental_texts.challenge).forEach(pid => {
					articleMap[pid] = {};
				});
			}
			if (assignment.opts.support) {
				Object.keys(product.supplemental_texts.support).forEach(pid => {
					articleMap[pid] = {};
				});
			}

			if (assignment.opts.decodables) {
				const assignedDecodables = new Set(assignment.opts.decodables);

				for (const dteGroup of product.dteGroups) {
					if (assignedDecodables.has(dteGroup.id)) {
						for (const pid in dteGroup.articles) {
							articleMap[pid] = {};
						}
					}
				}
			}
		}

		return _.assign({
			s: 'a',
			as: 'a',
			productId: assignment.p,
			opts: assignment.opts,
			scoreState: {
				aid: assignment.aid,
				a: articleMap,
				va: {
					rtw: {
						pre: {},
						post: {}
					},
					wb: false,
					wc: false,
					wm: false
				}
			}
		});
	});
};

module.exports = {
	createWorkspaceFromAssignment
};
